<template>
  <div>
    <div class="aboutContainer_pc">
      <div class="topRedPart">
        <div class="centerContent">
          <div class="leftTxt">
            <img
              class="coma"
              src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/coma.png"
            />
            <div class="mainTitle">NURIPACKS坚信</div>
            <div class="subTitle">
              每个人都是独特的个体，
              <br />我们都在追寻各自崇尚的生命价值。<br />
              健康的身体和心态会让这个过程 <br />变得更加积极而主动，<br />
              我们愿用营养和科技帮助你成为更好的自己！
            </div>
          </div>
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/topPic.png"
            alt=""
          />
        </div>
      </div>

      <div class="botGrayBox">
        <div class="partOne">
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/p1.png"
            alt=""
          />
          <div class="right">
            <div class="title">About NUTRIPACKS</div>
            <div class="subTitle">企业介绍</div>
            <div class="p_txt1">
              NUTRIPACKS橘袋，源自美国的专业营养品牌，由上市公司老肯医疗于2019年引进国内<br />并联合孵化；结合现代营养科学与数字技术前沿，利用大数据和人工智能为企业和个<br />人提供高品质、高标准、个性化的营养补充方案。
            </div>
            <div class="p_txt2">
              NUTRIPACKS橘袋极度在意补剂的品质，因为这不单是用户购买的消费品，更是为满足<br />健康需求所期待的答案。我们致力于提供100%透明的专业级配方，专注于产品成分的<br />生物可用性、准确剂量、优质辅料和先进生产工艺和严苛的食品安全和供应链管理，确<br />保每一粒补剂都符合专业级的成分纯度和稳定性标准，以达到预期的效力。
            </div>
          </div>
        </div>
        <div class="partTwo">
          <div class="center">
            <!-- <div class="item">
              <img
                class="icon"
                src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/circle_icon.png"
              />
              <div class="des">
                全球甄选<br />
                优质原料
              </div>
            </div> -->
            <div class="item">
              <img
                class="icon"
                src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/circle_icon.png"
              />
              <div class="des">
                美国TOP10<br />
                制药级厂商合作
              </div>
            </div>
            <div class="item">
              <img
                class="icon"
                src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/circle_icon.png"
              />
              <div class="des">
                NSF GMP<br />
                生产管理规范全链认证
              </div>
            </div>
            <div class="item">
              <img
                class="icon"
                src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/circle_icon.png"
              />
              <div class="des">
                100%美国制造 <br />
                保税区直邮
              </div>
            </div>
            <div class="item">
              <img
                class="icon"
                src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/circle_icon.png"
              />
              <div class="des">
                四川男排冠名 <br />
                合作营养品牌
              </div>
            </div>
          </div>
        </div>
        <div class="partThree">
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/p2.png"
            alt=""
          />
          <div class="right">
            <div class="title">Our Partners</div>
            <div class="subTitle">国内合作方</div>
            <div class="p_txt1">
              NUTRIPACKS橘袋与老肯医疗（股票代码：834611）战略合作，依托医疗级空气洁净<br />技术打造国内首家保税区内定制营养分装中心。
            </div>
            <div class="p_txt2">
              老肯医疗是中国医用级空气消毒净化领域的领军企业，工信部发布全国重点防疫企业。
            </div>
          </div>
        </div>
        <div class="partFour">
          <div class="right">
            <div class="title">Our Team</div>
            <div class="subTitle">荣誉团队</div>
            <div class="p_txt1">
              团队由资深营养学家、自然疗法医生，生物化学博士，营养配方学家、食品<br />安全学家及数据算法工程专家等共同组成。
            </div>
          </div>
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/p3.png"
            alt=""
          />
        </div>
        <div class="redTag"></div>
      </div>
      <div class="botBigPart">
        <div class="content">
          <div class="mainTitle">Cross-Border E-Commerce</div>
          <div class="mainDes">跨境电商</div>
          <div class="subTitle">
            美国原装进口 / 海关监管 /
            每一颗NUTRIPACKS橘袋从生产到销售均经过严格检测
          </div>
          <div class="subDes">
            跨境电商是两个不同国家之间商品通过正规的贸易规定进入到对方国家进行销售，经营者必须在该国家登记并取得合法的《工商营业执照》《食品经<br />营许可证》，产品进入该国必须严格接受海关检验检疫后并存放于保税区内，消费者购买是凭借身份证直接于官方或其他平台购买。出关再次对身份<br />和产品进行检验核对后，方可出关放行到达消费者手中。
          </div>
          <div class="items">
            <div class="item">
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/icon1.png"
                alt=""
              />
              <div class="des">
                美国生产<br />
                直供
              </div>
            </div>
            <div class="item">
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/icon2.png"
                alt=""
              />
              <div class="des">
                国际航空 <br />
                国际海运
              </div>
            </div>
            <div class="item">
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/icon3.png"
                alt=""
              />
              <div class="des">
                海关监控<br />
                保税仓储存
              </div>
            </div>
            <div class="item">
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/icon4.png"
                alt=""
              />
              <div class="des">
                国内配送<br />
                闪电发货
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="aboutContainer_m">
      <div class="topRedPart">
        <img
          class="coma"
          src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/coma.png"
        />
        <div class="mainTitle">NURIPACKS坚信</div>
        <div class="subTitle">
          每个人都是独特的个体，
          <br />我们都在追寻各自崇尚的生命价值。<br />
          健康的身体和心态会让这个过程 <br />变得更加积极而主动，<br />
          我们愿用营养和科技帮助你成为更好的自己！
        </div>
        <img
          class="img"
          src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/topPic_m.png"
          alt=""
        />
      </div>

      <div class="botWiteBox">
        <div class="partOne">
          <div class="title">About NUTRIPACKS</div>
          <div class="subTitle">企业介绍</div>
          <div class="p_txt1">
            NUTRIPACKS橘袋，源自美国的专业营养品牌，由上市公司老肯医疗于2019年引进国内并联合孵化；结合现代营养科学与数字技术前沿，利用大数据和人工智能为企业和个人提供高品质、高标准、个性化的营养补充方案。
          </div>
          <div class="p_txt2">
            NUTRIPACKS橘袋极度在意补剂的品质，因为这不单是用户购买的消费品，更是为满足健康需求所期待的答案。我们致力于提供100%透明的专业级配方，专注于产品成分的生物可用性、准确剂量、优质辅料和先进生产工艺和严苛的食品安全和供应链管理，确保每一粒补剂都符合专业级的成分纯度和稳定性标准，以达到预期的效力。
          </div>
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/p1_m.png"
            alt=""
            class="p1_414"
          />
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/p1_m_768.png"
            alt=""
            class="p1_768"
          />
        </div>
        <div class="partTwo">
          <div class="center">
            <!-- <div class="item">
              <img
                class="icon"
                src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/circle_icon.png"
              />
              <div class="des">
                全球甄选<br />
                优质原料
              </div>
            </div> -->
            <div class="item">
              <img
                class="icon"
                src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/circle_icon.png"
              />
              <div class="des">
                美国TOP10<br />
                制药级厂商合作
              </div>
            </div>
            <div class="item">
              <img
                class="icon"
                src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/circle_icon.png"
              />
              <div class="des">
                NSF GMP<br />
                生产管理规范全链认证
              </div>
            </div>
            <div class="item">
              <img
                class="icon"
                src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/circle_icon.png"
              />
              <div class="des">
                100%美国制造 <br />
                保税区直邮
              </div>
            </div>
            <div class="item">
              <img
                class="icon"
                src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/circle_icon.png"
              />
              <div class="des">
                四川男排冠名 <br />
                合作营养品牌
              </div>
            </div>
          </div>
        </div>
        <div class="partThree">
          <div class="title">Our Partners</div>
          <div class="subTitle">国内合作方</div>
          <div class="p_txt1">
            NUTRIPACKS橘袋与老肯医疗（股票代码：834611）战略合作，依托医疗级空气洁净技术打造国内首家保税区内定制营养分装中心。
          </div>
          <div class="p_txt2">
            老肯医疗是中国医用级空气消毒净化领域的领军企业，工信部发布全国重点防疫企业。
          </div>
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/p2.png"
            alt=""
          />
        </div>
        <div class="partFour">
          <div class="title">Our Team</div>
          <div class="subTitle">荣誉团队</div>
          <div class="p_txt1">
            团队由资深营养学家、自然疗法医生，生物化学博士，营养配方学家、食品安全学家及数据算法工程专家等共同组成。
          </div>
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/p3.png"
            alt=""
          />
        </div>
      </div>
      <div class="botBigPart">
        <div class="content">
          <div class="mainTitle">Cross-Border E-Commerce</div>
          <div class="mainDes">跨境电商</div>
          <div class="subTitle">
            美国原装进口 / 海关监管 /<br />
            每一颗NUTRIPACKS橘袋从生产到销售均经过严格检测
          </div>
          <div class="subTitle_oneline">
            美国原装进口 / 海关监管 /
            每一颗NUTRIPACKS橘袋从生产到销售均经过严格检测
          </div>
          <div class="subDes">
            跨境电商是两个不同国家之间商品通过正规的贸易规定进入到对方国家进行销售，经营者必须在该国家登记并取得合法的《工商营业执照》《食品经营许可证》，产品进入该国必须严格接受海关检验检疫后并存放于保税区内，消费者购买是凭借身份证直接于官方或其他平台购买。出关再次对身份和产品进行检验核对后，方可出关放行到达消费者手中。
          </div>
          <div class="items">
            <div class="item">
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/icon1.png"
                alt=""
              />
              <div class="des">
                美国生产<br />
                直供
              </div>
            </div>
            <div class="item">
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/icon2.png"
                alt=""
              />
              <div class="des">
                国际航空 <br />
                国际海运
              </div>
            </div>
            <div class="item">
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/icon3.png"
                alt=""
              />
              <div class="des">
                海关监控<br />
                保税仓储存
              </div>
            </div>
            <div class="item">
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/aboutUs/icon4.png"
                alt=""
              />
              <div class="des">
                国内配送<br />
                闪电发货
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
	<script>
if (navigator.userAgent.indexOf("AliApp") > -1) {
  document.writeln(
    '<script src="https://appx/web-view.min.js"' + ">" + "<" + "/" + "script>"
  );
}
</script>
	<script>
// my.onMessage = function(e) {
//     console.log(e); // {'sendToWebView': '1'}
// 		alert('123')
//   }
</script>
	<script>
import Swiper from "swiper";
import { md5 } from "../util/md5.js";
export default {
  name: "index",
  components: {},
  data: () => ({
    page: "home",
    items: [
      {
        id: 1,
        image:
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/storeimgs/about/about2.jpg",
      },
      {
        id: 2,
        image:
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/storeimgs/about/about2.jpg",
      },
      {
        id: 3,
        image:
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/storeimgs/about/about2.jpg",
      },
    ],
    list: [
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/storeimgs/about/about2.jpg",
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/storeimgs/about/about2.jpg",
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/storeimgs/about/about2.jpg",
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/storeimgs/about/about2.jpg",
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/storeimgs/about/about2.jpg",
    ],
  }),
  mounted() {
    new Swiper(".swiper-container", {
      slidesPerView: 4, // 每个视图显示 1.5 个滑块
      spaceBetween: 10, // 滑块之间的间隙
      centeredSlides: true, // 活动块居中
      loop: true, // 循环模式
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".custom-button-next",
        prevEl: ".custom-button-prev",
      },

      //   effect: "coverflow", // 使用 coverflow 效果
      // grabCursor: true,
      //   coverflowEffect: {
      //     rotate: 0, // 滑块的旋转角度
      //     stretch: 0, // 滑块的拉伸值
      //     depth: 100, // 滑块的深度
      //     modifier: 1, // 缩放比例
      //     slideShadows: false, // 是否显示阴影
      //   },
    });
  },
  created() {},
  methods: {
    prev() {
      this.$refs.carousel.prev();
    },
    next() {
      this.$refs.carousel.next();
    },
  },
};
</script>
	
<style scoped lang="scss">
//mobile414
@media screen and (max-width: 767px) {
  .aboutContainer_pc {
    display: none;
  }
  .aboutContainer_m {
    margin-top: 1.38rem;
    .topRedPart {
      background-color: #c25e4d;
      // height: 16.11rem;
      padding: 0 0.6rem;
      padding-bottom: 1.45rem;
      .coma {
        width: 0.87rem;
        height: 0.51rem;
        margin-top: 1.16rem;

        margin-right: calc(100% - 1.2rem);
      }
      .mainTitle {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 0.58rem;
        color: #ffffff;
        line-height: 0.7rem;
        text-align: left;
        font-style: normal;
        margin-top: 0.99rem;
      }
      .subTitle {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 0.29rem;
        color: #ffffff;
        line-height: 0.68rem;
        text-align: left;
        font-style: normal;
        margin-top: 0.77rem;
      }
      .img {
        // height: 6.18rem;
        height: auto;
        width: 100%;
        margin-top: 0.97rem;
      }
    }
    .botWiteBox {
      background-color: #fff;

      .partOne,
      .partThree,
      .partFour {
        padding: 0 0.6rem;
        padding-top: 1.45rem;

        .title {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.72rem;
          color: #141414;
          line-height: 0.85rem;
          text-align: center;
          font-style: normal;
        }
        .subTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.31rem;
          color: #000000;
          line-height: 0.43rem;
          text-align: center;
          font-style: normal;
          margin-top: 0.24rem;
        }
        .p_txt1 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.29rem;
          color: #141414;
          line-height: 0.68rem;
          text-align: left;
          font-style: normal;
          margin-top: 0.97rem;
        }
        .p_txt2 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.29rem;
          color: #141414;
          line-height: 0.68rem;
          text-align: left;
          font-style: normal;
          margin-top: 0.29rem;
        }
        img {
          width: 100%;
          // height: 8.82rem;
          height: auto;
          border-radius: 8px;
          margin-top: 0.97rem;
        }
        .p1_768 {
          display: none;
        }
      }
      .partTwo {
        background-color: #f6f4f1;
        padding: 0 0.6rem;
        padding-top: 1.43rem;
        padding-bottom: 1.45rem;
        margin-top: 1.45rem;
        .center {
          display: flex;
          flex-wrap: wrap;
          .item {
            display: flex;
            align-items: center;
            // background: red;
            // flex-direction: column;
            // align-items: start;
            // width: 33.33%;
            width: 50%;
            height: 50%;
            .icon {
              width: 0.72rem;
              height: 0.72rem;
              margin-right: 0.27rem;
            }
            .des {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 0.29rem;
              color: #141414;
              line-height: 0.41rem;
              text-align: left;
              font-style: normal;
            }
          }
          // .item:nth-child(3) {
          //   padding-left: 0.6rem;
          // }
          .item:nth-child(3) {
            margin-top: 0.97rem;
          }
          .item:nth-child(4) {
            margin-top: 0.97rem;
          }
        }
      }
    }
    .botBigPart {
      padding-top: 2.27rem;
      background-color: #fff;

      .content {
        width: 100%;
        height: 18.36rem;
        background-image: url(https://cdn-file.xiaojudai.cn/web/dist/aboutUs/p4_m.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        box-sizing: border-box;
        padding-top: 1.74rem;

        .mainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.72rem;
          color: #ffffff;
          line-height: 0.85rem;
          text-align: center;
          font-style: normal;
        }
        .mainDes {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.31rem;
          color: #ffffff;
          line-height: 0.43rem;
          text-align: center;
          font-style: normal;
          margin-top: 0.24rem;
        }
        .subTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 0.31rem;
          color: #ffffff;
          line-height: 0.68rem;
          text-align: center;
          font-style: normal;
          margin-top: 0.97rem;
        }
        .subTitle_oneline {
          display: none;
        }
        .subDes {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.29rem;
          color: #ffffff;
          line-height: 0.68rem;
          text-align: left;
          font-style: normal;
          padding: 0 0.6rem;
          margin-top: 0.29rem;
        }

        .items {
          display: flex;
          align-items: center;
          justify-content: space-around;
          margin-top: 0.94rem;
          .item {
            img {
              width: 1.11rem;
              height: 1.11rem;
              margin-bottom: 0.27rem;
            }
            .des {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 0.29rem;
              color: #ffffff;
              line-height: 0.41rem;
              text-align: center;
              font-style: normal;
            }
          }
        }
      }
    }
  }
}
//pad768
@media screen and (min-width: 768px) and (max-width: 1439px) {
  .aboutContainer_pc {
    display: none;
  }
  .aboutContainer_m {
    margin-top: 1.64rem;
    .topRedPart {
      background-color: #c25e4d;
      // height: 16.11rem;
      padding: 0 0.82rem;
      padding-bottom: 1.85rem;
      .coma {
        width: 0.92rem;
        height: 0.54rem;
        margin-top: 1.46rem;
        // margin-right: 10.24rem;
        margin-right: calc(100% - 3.98rem);
      }
      .mainTitle {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 0.63rem;
        color: #ffffff;
        line-height: 0.89rem;
        text-align: left;
        font-style: normal;

        margin-top: 1.12rem;
        margin-left: 50%;
        transform: translateX(-50%);
        height: 1.26rem;
      }
      .subTitle {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 0.26rem;
        color: #ffffff;
        line-height: 0.69rem;
        text-align: left;
        font-style: normal;

        margin-top: 0rem;
        margin-left: 50%;
        transform: translateX(-50%);
        // margin-top: 0.62rem;
      }
      .img {
        // height: 6.18rem;
        height: auto;
        width: 100%;
        margin-top: 1.14rem;
      }
    }
    .botWiteBox {
      background-color: #fff;

      .partOne,
      .partThree,
      .partFour {
        padding: 0 0.82rem;
        padding-top: 1.85rem;

        .title {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.81rem;
          color: #000000;
          line-height: 0.96rem;
          text-align: center;
          font-style: normal;
        }
        .subTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.41rem;
          color: #333333;
          line-height: 0.56rem;
          text-align: center;
          font-style: normal;
          margin-top: 0.15rem;
        }
        .p_txt1 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.26rem;
          color: #141414;
          line-height: 0.52rem;
          text-align: justify;
          font-style: normal;

          margin-top: 0.72rem;
        }
        .p_txt2 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.26rem;
          color: #141414;
          line-height: 0.52rem;
          text-align: justify;
          font-style: normal;

          margin-top: 0.22rem;
        }
        img {
          width: 100%;
          // height: 8.82rem;
          height: auto;
          border-radius: 8px;
          margin-top: 1.2rem;
        }
        .p1_414 {
          display: none;
        }
      }
      .partTwo {
        background-color: #f6f4f1;
        padding: 0 0.86rem;
        padding-top: 1.1rem;
        padding-bottom: 1.12rem;
        margin-top: 1.85rem;
        .center {
          display: flex;
          flex-wrap: wrap;
          .item {
            display: flex;
            align-items: center;
            // background: red;
            // flex-direction: column;
            // align-items: start;
            // width: 33.33%;
            width: 50%;
            height: 50%;
            .icon {
              width: 0.85rem;
              height: 0.85rem;
              margin-right: 0.4rem;
            }
            .des {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 0.26rem;
              color: #141414;
              line-height: 0.37rem;
              text-align: left;
              font-style: normal;
            }
          }
          // .item:nth-child(3) {
          //   padding-left: 0.6rem;
          // }
          .item:nth-child(3) {
            margin-top: 0.82rem;
          }
          .item:nth-child(4) {
            margin-top: 0.82rem;
          }
        }
      }
    }
    .botBigPart {
      padding-top: 1.85rem;
      background-color: #fff;

      .content {
        width: 100%;
        height: 18.22rem;
        background-image: url(https://cdn-file.xiaojudai.cn/web/dist/aboutUs/p4_m_768.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        box-sizing: border-box;
        padding-top: 1.82rem;

        .mainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.81rem;
          color: #ffffff;
          line-height: 0.96rem;
          text-align: center;
          font-style: normal;
        }
        .mainDes {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.41rem;
          color: #ffffff;
          line-height: 0.56rem;
          margin-top: 0.16rem;
        }
        .subTitle,
        .subTitle_oneline {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 0.3rem;
          color: #ffffff;
          line-height: 0.52rem;
          text-align: center;
          font-style: normal;
          margin-top: 0.74rem;
          display: none;
        }
        .subTitle_oneline {
          display: block;
        }
        .subDes {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.26rem;
          color: #ffffff;
          line-height: 0.52rem;
          font-style: normal;
          text-align: left;
          padding: 0 0.82rem;
          margin-top: 0rem;
        }

        .items {
          display: flex;
          align-items: center;
          justify-content: space-around;
          margin-top: 1.4rem;
          .item {
            img {
              width: 1.74rem;
              height: 1.74rem;
              margin-bottom: 0.38rem;
            }
            .des {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 0.26rem;
              color: #fff;
              line-height: 0.37rem;
              text-align: center;
              font-style: normal;
            }
          }
        }
      }
    }
  }
}
//小web1440
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .aboutContainer_pc {
    .topRedPart {
      background-color: #c25e4d;
      height: 12.89rem;
      display: flex;
      justify-content: center;
      align-items: center;
      .centerContent {
        display: flex;
        align-items: center;
        .leftTxt {
          position: relative;
          margin-right: 4.12rem;
          .coma {
            width: 0.92rem;
            height: 0.54rem;
            position: absolute;
            top: -1.66rem;
            left: -1.2rem;
          }
          .mainTitle {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 0.63rem;
            color: #ffffff;
            line-height: 0.89rem;
            text-align: left;
            font-style: normal;
            height: 1.26rem;
          }
          .subTitle {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.26rem;
            color: #ffffff;
            line-height: 0.69rem;
            text-align: left;
            font-style: normal;
          }
        }
        img {
          width: 12.12rem;
          height: auto;
        }
      }
    }
    .botGrayBox {
      // background-color: #f0f2f5;
      background-color: #fff;
      padding-top: 2.22rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .partOne,
      .partThree,
      .partFour {
        display: flex;
        align-items: center;
        img {
          width: 10.74rem;
          height: 10.74rem;
          margin-right: 2.18rem;
        }
        .right {
          min-width: 9.96rem;
          .title {
            font-family: MADEEvolveSans, MADEEvolveSans;
            font-weight: bold;
            font-size: 0.81rem;
            color: #000000;
            line-height: 0.96rem;
            text-align: left;
            font-style: normal;
          }
          .subTitle {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.41rem;
            color: #333333;
            line-height: 0.56rem;
            text-align: left;
            font-style: normal;
            margin-top: 0.15rem;
          }
          .p_txt1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.26rem;
            color: #141414;
            line-height: 0.52rem;
            text-align: left;
            font-style: normal;
            margin-top: 0.72rem;
          }
          .p_txt2 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.26rem;
            color: #141414;
            line-height: 0.52rem;
            text-align: left;
            font-style: normal;
            margin-top: 0.22rem;
          }
        }
      }
      .partTwo {
        width: 100%;
        height: 4.59rem;
        background: #f6f4f1;
        margin-top: 2.22rem;
        display: flex;
        justify-content: center;
        .center {
          display: flex;
          align-items: center;
          justify-content: space-between;

          width: 22.87rem;
          height: 100%;
          // background-color: red;
          .item {
            display: flex;
            align-items: center;
            height: 100%;
            // background-color: red;
            // flex-direction: column;
            // align-items: start;
            .icon {
              width: 0.85rem;
              height: 0.85rem;
              // margin-bottom: 0.39rem;
              margin-right: 0.39rem;
            }
            .des {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 0.26rem;
              color: #141414;
              line-height: 0.37rem;
              text-align: left;
              font-style: normal;
            }
          }
        }
      }
      .partThree,
      .partFour {
        margin-top: 2.22rem;
      }
      .partFour {
        // position: relative;
        img {
          margin-right: 0;
          margin-left: 2.6rem;
        }
        .right {
          padding-left: 0.6rem;
        }
      }
      .redTag {
        width: 1.89rem;
        height: 1.89rem;
        background: #c25e4d;
        box-shadow: 0rem 0.04rem 0.07rem 0rem rgba(0, 0, 0, 0.08);

        position: absolute;
        left: 0;
        bottom: 0;
      }
    }
    .botBigPart {
      padding: 2.46rem 0;
      // background-color: #f0f2f5;
      background-color: #fff;

      .content {
        width: 100%;
        height: 18.44rem;
        background-image: url(https://cdn-file.xiaojudai.cn/web/dist/aboutUs/p4_1440.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        box-sizing: border-box;
        padding-top: 2.46rem;

        .mainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.81rem;
          color: #ffffff;
          line-height: 0.96rem;
          text-align: center;
          font-style: normal;
        }
        .mainDes {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.41rem;
          color: #ffffff;
          line-height: 0.56rem;
          text-align: center;
          font-style: normal;
        }
        .subTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 0.3rem;
          color: #ffffff;
          line-height: 0.52rem;
          text-align: center;
          font-style: normal;

          margin-top: 50px;
        }
        .subDes {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.26rem;
          color: #ffffff;
          line-height: 0.52rem;
          text-align: center;
          font-style: normal;
        }

        .items {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 50px;
          .item {
            margin-right: 2.037rem;

            img {
              width: 1.76rem;
              height: 1.76rem;
              margin-bottom: 0.3704rem;
            }
            .des {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 0.26rem;
              color: #141414;
              line-height: 0.37rem;
              text-align: center;
              font-style: normal;
              color: #fff;
            }
          }
          .item:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
  .aboutContainer_m {
    display: none;
  }
}
// 1920
@media screen and (min-width: 1920px) {
  .aboutContainer_pc {
    .topRedPart {
      background-color: #c25e4d;
      height: 12.89rem;
      display: flex;
      justify-content: center;
      align-items: center;
      .centerContent {
        display: flex;
        align-items: center;
        .leftTxt {
          position: relative;
          margin-right: 5.5556rem;
          .coma {
            width: 0.89rem;
            height: 0.51rem;
            position: absolute;
            top: -1.62rem;
            left: -1.63rem;
          }
          .mainTitle {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 0.63rem;
            color: #ffffff;
            line-height: 0.89rem;
            text-align: left;
            font-style: normal;
          }
          .subTitle {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.26rem;
            color: #ffffff;
            line-height: 0.69rem;
            text-align: left;
            font-style: normal;
          }
        }
        img {
          width: 13.65rem;
          height: 8.44rem;
        }
      }
    }
    .botGrayBox {
      // background-color: #f0f2f5;
      background-color: #fff;
      padding-top: 2.96rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .partOne,
      .partThree,
      .partFour {
        display: flex;
        align-items: center;
        img {
          width: 12.26rem;
          height: 12.26rem;
          margin-right: 2.59rem;
        }
        .right {
          min-width: 9.94rem;
          .title {
            font-family: MADEEvolveSans, MADEEvolveSans;
            font-weight: bold;
            font-size: 0.81rem;
            color: #000000;
            line-height: 0.96rem;
            text-align: left;
            font-style: normal;
          }
          .subTitle {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.41rem;
            color: #333333;
            line-height: 0.56rem;
            text-align: left;
            font-style: normal;
            margin-top: 0.15rem;
          }
          .p_txt1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.26rem;
            color: #141414;
            line-height: 0.52rem;
            text-align: left;
            font-style: normal;
            margin-top: 0.72rem;
          }
          .p_txt2 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.26rem;
            color: #141414;
            line-height: 0.52rem;
            text-align: left;
            font-style: normal;
            margin-top: 0.22rem;
          }
        }
      }
      .partTwo {
        width: 100%;
        height: 4.59rem;
        background: #f6f4f1;
        margin-top: 2.96rem;
        display: flex;
        justify-content: center;
        .center {
          display: flex;
          align-items: center;
          justify-content: space-between;

          width: 22.2222rem;
          height: 100%;
          // background-color: red;
          .item {
            display: flex;
            align-items: center;
            height: 100%;
            // background-color: red;
            // flex-direction: column;
            // align-items: start;
            .icon {
              width: 0.85rem;
              height: 0.85rem;
              // margin-bottom: 0.39rem;
              margin-right: 0.39rem;
            }
            .des {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 0.26rem;
              color: #141414;
              line-height: 0.37rem;
              text-align: left;
              font-style: normal;
            }
          }
        }
      }
      .partThree,
      .partFour {
        margin-top: 2.96rem;
      }
      .partFour {
        // position: relative;
        img {
          margin-right: 0;
          margin-left: 4rem;
        }
        .right {
          padding-left: 1.41rem;
        }
      }
      .redTag {
        width: 1.89rem;
        height: 1.89rem;
        background: #c25e4d;
        box-shadow: 0rem 0.04rem 0.07rem 0rem rgba(0, 0, 0, 0.08);

        position: absolute;
        left: 0;
        bottom: 0;
      }
    }
    .botBigPart {
      padding: 2.46rem 0;
      // background-color: #f0f2f5;
      background-color: #fff;

      .content {
        width: 100%;
        height: 20.96rem;
        background-image: url(https://cdn-file.xiaojudai.cn/web/dist/aboutUs/p4.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        box-sizing: border-box;
        padding-top: 2.46rem;

        .mainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.81rem;
          color: #ffffff;
          line-height: 0.96rem;
          text-align: center;
          font-style: normal;
        }
        .mainDes {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.41rem;
          color: #ffffff;
          line-height: 0.56rem;
          text-align: center;
          font-style: normal;
        }
        .subTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 0.3rem;
          color: #ffffff;
          line-height: 0.52rem;
          text-align: center;
          font-style: normal;

          margin-top: 50px;
        }
        .subDes {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.26rem;
          color: #ffffff;
          line-height: 0.52rem;
          text-align: center;
          font-style: normal;
        }

        .items {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 50px;
          .item {
            margin-right: 2.037rem;

            img {
              width: 1.76rem;
              height: 1.76rem;
              margin-bottom: 0.3704rem;
            }
            .des {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 0.26rem;
              color: #141414;
              line-height: 0.37rem;
              text-align: center;
              font-style: normal;
              color: #fff;
            }
          }
          .item:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
  .aboutContainer_m {
    display: none;
  }
}
</style>
	